module.exports = __webpack_public_path__ + "img/live-panel-dark.cea0f1f8.svg";